import { useContext, useRef, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { API_UnsubscribeJobAlerts } from "../../../apis/ApisJobAlerts";
import { Colour } from "../../Variables";
import { Card } from "../Shared/Card";
import { ErrorsDisplay } from "../Shared/Error";

export function JobAlertsUnsubscribeForm() {
    const app = useContext(AppContext);

    const [sending, setSending] = useState<boolean>(false);
    const [username, setUsername] = useState<string>('');

    const inputUsernameRef = useRef<HTMLInputElement>(null);
    const [errors, setErrors] = useState<string[]>([]);

    const sendRequest = async () => {

        if ((username?.length ?? 0) == 0) {
            setErrors(["Please provide a username"]);
            inputUsernameRef?.current?.classList.remove("is-valid");
            inputUsernameRef?.current?.classList.add("is-invalid");
        }
        else {
            setErrors([]);
            inputUsernameRef?.current?.classList.add("is-valid");
            inputUsernameRef?.current?.classList.remove("is-invalid");
            setSending(true);
            await API_UnsubscribeJobAlerts(username);
        }
    }

    return (
        <Card title={`Unsubscribe from ${app.firmName} job alert subscriptions`} headerTheme={Colour.Alt} headerClasses={"mt-4"} >
            {!sending && <p>
                To unsubscribe from all marketing emails please enter your username and click unsubscribe.
            </p>}

            <ErrorsDisplay errors={errors} />

            {sending && <div className="alert alert-info mb-0"> If your account details have been matched you will no longer receive any marketing emails. <br /><br /> Please allow up to 5 working days for this request to be processed.</div>}

            {!sending &&
                <div className="col-auto">
                    <label htmlFor="usernamecontrol" className="form-label-alt">Username</label>
                    <div className="input-group">
                        <input ref={inputUsernameRef} placeholder="Username" id="usernamecontrol" aria-label="Username" className="form-control"
                            value={username}
                            type="text"
                            autoComplete="off"
                            onChange={t => {
                                setUsername(t.currentTarget.value);
                                inputUsernameRef?.current?.classList.remove("is-valid");
                                inputUsernameRef?.current?.classList.remove("is-invalid");
                            }} />

                        <button className="btn btn-alt" disabled={sending || username.length == 0} type="submit" onClick={e => {
                            e.preventDefault();
                            sendRequest();
                        }}>Unsubscribe</button>
                    </div>
                    <div className="invalid-feedback">
                        Please provide a username
                    </div>
                </div>
            }
        </Card>
    );
}